import React, { Component } from 'react'
import { app } from "@microsoft/teams-js";
import Utils from "./../common/Utils";
import { iniApplicationId, iniApiImpersonation } from "../../ini/ini";
import './Login.scss'

export default class Login extends Component {

    state = {
        loginHint: ""
    }

    componentDidMount() {
        app.initialize().then(() => {
            app.getContext().then((context) => {
                this.setState({ loginHint: context.user?.loginHint || "" }, () => {
                    this.timerID = setInterval(
                        () => this.authenticate(),
                        1000
                    );
                });
            });
        }).catch(() => {
            this.timerID = setInterval(
                () => this.authenticate(),
                1000
            );
        });          
    }

    authenticate() {
        clearInterval(this.timerID);
        let queryParams = {
            client_id: iniApplicationId,
            response_type: "id_token token",
            response_mode: "fragment",
            ressource: iniApplicationId,
            grant_type: "client_credentials",
            scope: "openid profile User.ReadBasic.All User.Read" + " " + iniApiImpersonation,
            nonce: Utils.guidGenerator(),
            state: Utils.guidGenerator(),
            redirect_uri: window.location.origin + "/loginResult",
            login_hint: this.state.loginHint != null ? this.state.loginHint : "",
            requested_token_use: "on_behalf_of"
        };
        // Silent login failed with several Microsoft sessions in this browser, so let Entra ID
        // ask which account to use. In Teams the account comes from the Teams context instead.
        if (!this.state.loginHint && window.sessionStorage.getItem("ri_select_account") === "1") {
            window.sessionStorage.removeItem("ri_select_account");
            delete queryParams.login_hint;
            queryParams.prompt = "select_account";
        }
        var esc = encodeURIComponent;
        var query = Object.keys(queryParams)
            .map(k => esc(k) + '=' + esc(queryParams[k]))
            .join('&');
        let authorizeEndpoint = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?" + query
        console.log("Login Page with loginHint:" + this.state.loginHint + " Url: " + authorizeEndpoint);
        window.location.assign(authorizeEndpoint);
    }

    render() {
        return (
            <div className="login-body">
            </div>
        );
    }
}
